import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { setTheme, themeSelector } from "../slice";

export const useTheme = () => {
  const theme = useAppSelector(themeSelector);

  const dispatch = useAppDispatch();

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const toggleTheme = () => {
    if (theme === "dark") {
      dispatch(setTheme("light"));
      return;
    }
    dispatch(setTheme("dark"));
  };

  return { theme, toggleTheme };
};
